var map = {
	"./coin.json": [
		9182,
		182
	],
	"./enemy.json": [
		8263,
		263
	],
	"./hero.json": [
		292,
		292
	],
	"./npc_01.json": [
		6142,
		142
	],
	"./npc_02.json": [
		3550,
		550
	],
	"./npc_03.json": [
		5212,
		212
	],
	"./npc_04.json": [
		5460,
		460
	],
	"./npc_05.json": [
		1254,
		254
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4162;
module.exports = webpackAsyncContext;